module.exports = __webpack_public_path__ + "img/icon-dexcards.f4922d0b.svg";